var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    { staticClass: "support-sidebar", attrs: { id: "sk-sidebar-accordion" } },
    [
      _c(
        "ul",
        { staticClass: "support-sidebar__categories" },
        _vm._l(_vm.faqLinks, function(category, categoryIndex) {
          return _c(
            "li",
            {
              key: categoryIndex,
              staticClass: "support-sidebar__category control",
              class: _vm.categoryClass(categoryIndex),
              on: {
                click: function($event) {
                  return _vm.categoryClicked(categoryIndex)
                }
              }
            },
            [
              _c("p", [_vm._v(_vm._s(category.name))]),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "support-sidebar__articles target",
                  style: _vm.childStyle(categoryIndex)
                },
                _vm._l(category.links, function(link, linkIndex) {
                  return _c(
                    "li",
                    { key: linkIndex, class: _vm.linkClass(link.isActive) },
                    [
                      _c("a", {
                        attrs: { href: link.url },
                        domProps: { innerHTML: _vm._s(link.title) }
                      })
                    ]
                  )
                }),
                0
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }